import api from '../utils/axiosConfig';
import { Nis2Assessment, Nis2Report, Nis2Stage, Nis2StageStatus } from '../types/nis2';

export class Nis2Service {
  static async getReport(ticketId: string): Promise<Nis2Report> {
    try {
      const response = await api.get(`/tickets/${ticketId}/nis2-report`);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Failed to load NIS2 report');
    }
  }

  static async updateAssessment(
    ticketId: string,
    payload: { awareness_at?: string | null; assessment?: Nis2Assessment },
  ): Promise<Nis2Report> {
    try {
      const response = await api.put(`/tickets/${ticketId}/nis2-report`, payload);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Failed to save NIS2 assessment');
    }
  }

  static async saveStage(
    ticketId: string,
    stage: Nis2Stage,
    data: object,
    status: Nis2StageStatus = 'draft',
    submittedAt?: string,
  ): Promise<Nis2Report> {
    try {
      const response = await api.post(`/tickets/${ticketId}/nis2-notifications`, {
        stage,
        data,
        status,
        ...(submittedAt ? { submitted_at: submittedAt } : {}),
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.error || 'Failed to save NIS2 report');
    }
  }
}
